<template>
  <v-sheet class="big-bar-sheet" elevation="2" :color="ui.primaryColor">
    <v-row class="align-center pa-0 ma-0">
      <v-col cols="5" class="mb-n10 pt-10 ps-5">
        <v-img
          :src="ui.squareLogoLink"
          class="rounded-xl shop-image border-0"
        />
      </v-col>
      <v-col cols="7" class="mb-n10 pt-10 ps-0 text-start">
        <h1 class="shop-name">
          {{ ui.name }}
        </h1>
      </v-col>
    </v-row>
  </v-sheet>
  <v-sheet class="pt-5 bg-transparent">
    <v-row class="align-center pa-0 ma-0">
      <v-col cols="7" class="ps-5">
        <p>{{ profile.displayName }}</p>
        <v-divider />
        <p>{{ profile.fullName }}</p>
        <router-link
          :to="{ name: 'membershipWalletTopUp' }"
          v-if="shopDetail.feature_enable.member_wallet"
          class="wallet-display"
        >
          <v-sheet
            :color="ui.primaryColor"
            class="pa-3 mt-3 d-flex"
            rounded="lg"
            elevation="2"
          >
            <v-icon icon="mdi-wallet-bifold-outline"></v-icon>
            <div class="ms-auto">{{ profile.walletAmount }} THB</div>
          </v-sheet>
        </router-link>
      </v-col>
      <v-col cols="5" class="pa-3 pe-5">
        <v-avatar
          icon="mdi-account"
          size="128"
          class="profile-image"
          :image="profile.pictureUrl"
          :color="ui.primaryColor"
        >
          <v-img v-if="profile.pictureUrl != null" :src="profile.pictureUrl" />
          <span v-if="profile.pictureUrl == null" class="text-h2">SS</span>
        </v-avatar>
      </v-col>
    </v-row>
  </v-sheet>
  <fund-carousel :color="ui.secondaryColor" :funds="profile.funds" />
  <v-divider class="mx-5" />
  <div id="menu-item" v-if="isMenuVisible">
    <landing-menu-item
      icon="mdi-calendar-plus-outline"
      title="Book for a Class"
      description="จอง class เรียน"
      :to="{ name: 'classInfo', query: { memberId: $route.params.memberId } }"
      v-if="shopDetail.feature_enable.class_event"
    />
    <landing-menu-item
      icon="mdi-calendar-plus-outline"
      title="Book for Facility"
      description="จองใช้บริการ"
      :to="{
        name: 'facilityInfo',
        query: { memberId: $route.params.memberId },
      }"
      v-if="shopDetail.feature_enable.facility_event"
    />
    <landing-menu-item
      icon="mdi-calendar-clock"
      title="Facility Schedule"
      description="ตารางการใช้บริการ"
      :to="{ name: 'membershipFacilitySchedule' }"
      v-if="shopDetail.feature_enable.facility_event"
    />
    <landing-menu-item
      icon="mdi-calendar-plus-outline"
      title="Book for Open Private"
      description="จองใช้บริการส่วนตัว"
      :to="{
        name: 'openPrivateInfo',
        query: { memberId: $route.params.memberId },
      }"
      v-if="shopDetail.feature_enable.open_private_event"
    />
    <landing-menu-item
      icon="mdi-basket-outline"
      title="Purchase Package"
      description="ซื้อ package"
      :to="{ name: 'membershipPurchasePackage' }"
      v-if="shopDetail.feature_enable.package_purchasing"
    />
    <landing-menu-item
      icon="mdi-history"
      title="Class History"
      description="ประวัติการใช้ class เรียน"
      :to="{ name: 'membershipHistory' }"
      v-if="shopDetail.feature_enable.class_event"
    />
    <landing-menu-item
      icon="mdi-history"
      title="Facility History"
      description="ประวัติการใช้บริการ"
      :to="{ name: 'membershipFacilityHistory' }"
      v-if="shopDetail.feature_enable.facility_event"
    />
    <landing-menu-item
      icon="mdi-history"
      title="Open Private History"
      description="ประวัติการใช้บริการส่วนตัว"
      :to="{ name: 'membershipOpenPrivateHistory' }"
      v-if="shopDetail.feature_enable.open_private_event"
    />
    <landing-menu-item
      icon="mdi-cog-outline"
      title="Settings"
      description="ตั้งค่าบัญชี"
      :to="{ name: 'membershipSetting' }"
    />
    <v-img
      v-if="shopDetail.member_page_image_link"
      :src="shopDetail.member_page_image_link"
      class="mt-4 mx-4 mb-4 rounded-xl"
      cover
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import FundCarousel from "@/components/membership/FundCarousel.vue";
import LandingMenuItem from "@/components/membership/LandingMenuItem.vue";
import { useUi } from "@/util/ShopUi.js";
import { useProfile } from "@/util/MemberProfile.js";
import { useRoute } from "vue-router";
import BackendConnector from "@/util/BackendConnector";
import axios from "axios";

const route = useRoute();
const ui = ref({});
const shopDetail = ref({ feature_enable: {} });
const isMenuVisible = ref(true);

useUi(route.params.shopId).then((responseUi) => {
  ui.value = responseUi;
});
const profile = ref({ funds: [] });
doPaymentConfirm(route.params.memberId).then(() => {
  useProfile(route.params.memberId).then((responseProfile) => {
    profile.value = responseProfile;
    console.log(profile);
  });
});

BackendConnector.loadShopDetail(route.params.shopId).then((response) => {
  shopDetail.value = response.data;
  if (is_shop_expired(new Date(shopDetail.value.next_billing_date))) {
    alert("ร้านค้าหมดอายุ กรุณาติดต่อร้านค้าที่ให้บริการ");
    isMenuVisible.value = false;
  }
});

function is_shop_expired(billing_date) {
  console.log(billing_date);
  const today = new Date();
  return today > billing_date;
}

function doPaymentConfirm(memberId) {
  return axios({
    type: "GET",
    url: `${process.env.VUE_APP_BACKEND_URL}/api/member/id-${memberId}/do_payment_confirm`,
  });
}
</script>

<style scoped>
.shop-image {
  border: 5px solid white;
}

.shop-name {
  font-size: 1.5rem;
  font-weight: 600;
}

.profile-image {
  border: 5px solid white;
  font-size: 3.5rem;
}

.wallet-display {
  text-decoration: none !important;
}
</style>
